// extracted by mini-css-extract-plugin
export default {"motion":"motion__cc395e0e","scroll":"scroll__cc395e0e","main_image":"main_image__cc395e0e","motion_slogan":"motion_slogan__cc395e0e"};